import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    /* Main Colors */
    --grey-2: var(--override-grey-2, ${({ theme }) => theme.colors.main.grey2});
    --grey-5: var(--override-grey-5, ${({ theme }) => theme.colors.main.grey5});
    --grey-10: var(--override-grey-10, ${({ theme }) => theme.colors.main.grey10});
    --grey-20: var(--override-grey-20, ${({ theme }) => theme.colors.main.grey20});
    --grey-30: var(--override-grey-30, ${({ theme }) => theme.colors.main.grey30});
    --grey-40: var(--override-grey-40, ${({ theme }) => theme.colors.main.grey40});
    --grey-50: var(--override-grey-50, ${({ theme }) => theme.colors.main.grey50});
    --grey-60: var(--override-grey-60, ${({ theme }) => theme.colors.main.grey60});
    --grey-70: var(--override-grey-70, ${({ theme }) => theme.colors.main.grey70});
    --grey-80: var(--override-grey-80, ${({ theme }) => theme.colors.main.grey80});
    --grey-90: var(--override-grey-90, ${({ theme }) => theme.colors.main.grey90});
    --grey-95: var(--override-grey-95, ${({ theme }) => theme.colors.main.grey95});

    /* Accent Colors - These can now be overridden by white label */
    --blue-2: var(--override-blue-2, ${({ theme }) => theme.colors.accent.blue2});
    --blue-5: var(--override-blue-5, ${({ theme }) => theme.colors.accent.blue5});
    --blue-10: var(--override-blue-10, ${({ theme }) => theme.colors.accent.blue10});
    --blue-20: var(--override-blue-20, ${({ theme }) => theme.colors.accent.blue20});
    --blue-30: var(--override-blue-30, ${({ theme }) => theme.colors.accent.blue30});
    --blue-40: var(--override-blue-40, ${({ theme }) => theme.colors.accent.blue40});
    --blue-50: var(--override-blue-50, ${({ theme }) => theme.colors.accent.blue50});
    --blue-60: var(--override-blue-60, ${({ theme }) => theme.colors.accent.blue60});
    --blue-70: var(--override-blue-70, ${({ theme }) => theme.colors.accent.blue70});
    --blue-80: var(--override-blue-80, ${({ theme }) => theme.colors.accent.blue80});
    --blue-90: var(--override-blue-90, ${({ theme }) => theme.colors.accent.blue90});
    --blue-95: var(--override-blue-95, ${({ theme }) => theme.colors.accent.blue95});
    --yellow-50: var(--override-yellow-50, ${({ theme }) => theme.colors.accent.yellow50});

    /* Error Colors */
    --red-2: ${({ theme }) => theme.colors.error.red2};
    --red-5: ${({ theme }) => theme.colors.error.red5};
    --red-10: ${({ theme }) => theme.colors.error.red10};
    --red-20: ${({ theme }) => theme.colors.error.red20};
    --red-30: ${({ theme }) => theme.colors.error.red30};
    --red-40: ${({ theme }) => theme.colors.error.red40};
    --red-50: ${({ theme }) => theme.colors.error.red50};
    --red-60: ${({ theme }) => theme.colors.error.red60};
    --red-70: ${({ theme }) => theme.colors.error.red70};
    --red-80: ${({ theme }) => theme.colors.error.red80};
    --red-90: ${({ theme }) => theme.colors.error.red90};
    --red-95: ${({ theme }) => theme.colors.error.red95};

    /* Success Colors */
    --green-2: ${({ theme }) => theme.colors.success.green2};
    --green-5: ${({ theme }) => theme.colors.success.green5};
    --green-10: ${({ theme }) => theme.colors.success.green10};
    --green-20: ${({ theme }) => theme.colors.success.green20};
    --green-30: ${({ theme }) => theme.colors.success.green30};
    --green-40: ${({ theme }) => theme.colors.success.green40};
    --green-50: ${({ theme }) => theme.colors.success.green50};
    --green-60: ${({ theme }) => theme.colors.success.green60};
    --green-70: ${({ theme }) => theme.colors.success.green70};
    --green-80: ${({ theme }) => theme.colors.success.green80};
    --green-90: ${({ theme }) => theme.colors.success.green90};
    --green-95: ${({ theme }) => theme.colors.success.green95};

    --purple-50: ${({ theme }) => theme.colors.other.purple50};

    
    /* Other Colors */
    --white: #ffffff;
    --black: #000000;
    --yellow: #ffcc00;

    /* Decorative Gradients */
    --gradients-light: linear-gradient(90deg, rgba(153, 213, 255, 1) 0%, rgba(0, 149, 255, 1) 100%);
    --gradients-medium: linear-gradient(90deg, rgba(0, 149, 255, 1) 0%, rgba(0, 60, 102, 1) 100%);
    --gradients-black: linear-gradient(90deg, rgba(48, 50, 54, 1) 0%, rgba(12, 13, 13, 1) 100%);

    /* Font Variables */
    --title-title-1-font-family: 'Montserrat SemiBold';
    --title-title-1-font-size: 28px;
    --title-title-1-line-height: 39px;
    --title-title-1-font-weight: 600;
    --title-title-1-font-style: normal;

    --small-title-regular-font-family: 'Montserrat Regular';
    --small-title-regular-font-size: 21px;
    --small-title-regular-line-height: 28px;
    --small-title-regular-font-weight: 400;
    --small-title-regular-font-style: normal;

    --small-title-semibold-font-family: 'Montserrat SemiBold';
    --small-title-semibold-font-size: 21px;
    --small-title-semibold-line-height: 28px;
    --small-title-semibold-font-weight: 600;
    --small-title-semibold-font-style: normal;

    --highlight-medium-font-family: 'Montserrat Medium';
    --highlight-medium-font-size: 16px;
    --highlight-medium-line-height: 22px;
    --highlight-medium-font-weight: 500;
    --highlight-medium-font-style: normal;

    --highlight-bold-font-family: 'Montserrat Bold';
    --highlight-bold-font-size: 16px;
    --highlight-bold-line-height: 22px;
    --highlight-bold-font-weight: 700;
    --highlight-bold-font-style: normal;

    --body-text-regular-font-family: 'Montserrat Regular';
    --body-text-regular-font-size: 14px;
    --body-text-regular-line-height: 19px;
    --body-text-regular-font-weight: 400;
    --body-text-regular-font-style: normal;

    --body-text-medium-font-family: 'Montserrat Medium';
    --body-text-medium-font-size: 14px;
    --body-text-medium-line-height: 19px;
    --body-text-medium-font-weight: 500;
    --body-text-medium-font-style: normal;

    --body-text-semibold-font-family: 'Montserrat SemiBold';
    --body-text-semibold-font-size: 14px;
    --body-text-semibold-line-height: 19px;
    --body-text-semibold-font-weight: 600;
    --body-text-semibold-font-style: normal;

    --body-text-bold-font-family: 'Montserrat Bold';
    --body-text-bold-font-size: 14px;
    --body-text-bold-line-height: 19px;
    --body-text-bold-font-weight: 700;
    --body-text-bold-font-style: normal;

    --footnote-light-font-family: 'Montserrat Light';
    --footnote-light-font-size: 12px;
    --footnote-light-line-height: 16px;
    --footnote-light-font-weight: 300;
    --footnote-light-font-style: normal;

    --footnote-regular-font-family: 'Montserrat Regular';
    --footnote-regular-font-size: 12px;
    --footnote-regular-line-height: 16px;
    --footnote-regular-font-weight: 400;
    --footnote-regular-font-style: normal;

    --footnote-medium-font-family: 'Montserrat Medium';
    --footnote-medium-font-size: 12px;
    --footnote-medium-line-height: 16px;
    --footnote-medium-font-weight: 500;
    --footnote-medium-font-style: normal;

    --footnote-semibold-font-family: 'Montserrat SemiBold';
    --footnote-semibold-font-size: 12px;
    --footnote-semibold-line-height: 16px;
    --footnote-semibold-font-weight: 600;
    --footnote-semibold-font-style: normal;

    --body-text-small-font-size: 13px;
    --footnote-small-font-size: 10px;
    --contract-form-thumbnail-font-size: 5.5px;
    --contract-form-serif-font-family: "Times New Roman", serif;
    --contract-form-sans-font-family: Arial, sans-serif;
    --icon-size-lg: 32px;

    // TODO : updated to viewer logic
    --svg-blue-50-filter: invert(43%) sepia(97%) saturate(3185%) hue-rotate(185deg) brightness(103%) contrast(105%);
    --svg-white-filter: invert(1) brightness(100);
    --svg-blue-60-filter: invert(31%) sepia(27%) saturate(4727%) hue-rotate(185deg) brightness(98%)
      contrast(103%);
    --svg-grey-20-filter: invert(77%) sepia(5%) saturate(145%) hue-rotate(182deg) brightness(101%)
      contrast(102%);
    --svg-grey-50-filter: invert(52%) sepia(3%) saturate(864%) hue-rotate(178deg) brightness(93%)
      contrast(89%);

    --border-grey-5: 1px solid var(--grey-5, #f2f2f3);
    --border-grey-20: 1px solid var(--grey-20, #c9cbcf);
  }
  /* Font Classes */
  .section-title {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--title-title-1-font-family, 'Montserrat SemiBold') !important;
    font-size: var(--title-title-1-font-size, 28px) !important;
    line-height: var(--title-title-1-line-height, 39px) !important;
    font-weight: var(--title-title-1-font-weight, 600) !important;
    position: relative !important;
  }

  .small-title {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--small-title-regular-font-family, 'Montserrat Regular') !important;
    font-size: var(--small-title-regular-font-size, 21px) !important;
    line-height: var(--small-title-regular-line-height, 28px) !important;
    font-weight: var(--small-title-regular-font-weight, 400) !important;
    position: relative !important;
  }

  .small-title2 {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--small-title-semibold-font-family, 'Montserrat SemiBold') !important;
    font-size: var(--small-title-semibold-font-size, 21px) !important;
    line-height: var(--small-title-semibold-line-height, 28px) !important;
    font-weight: var(--small-title-semibold-font-weight, 600) !important;
    position: relative !important;
  }

  .highlight {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--highlight-medium-font-family, 'Montserrat Medium') !important;
    font-size: var(--highlight-medium-font-size, 16px) !important;
    line-height: var(--highlight-medium-line-height, 22px) !important;
    font-weight: var(--highlight-medium-font-weight, 500) !important;
    position: relative !important;
  }
  .highlight2 {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--highlight-bold-font-family, 'Montserrat Bold') !important;
    font-size: var(--highlight-bold-font-size, 16px) !important;
    line-height: var(--highlight-bold-line-height, 22px) !important;
    font-weight: var(--highlight-bold-font-weight, 700) !important;
    position: relative !important;
  }
  .body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: normal;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
  }
  .body-text {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--body-text-regular-font-family, 'Montserrat Regular') !important;
    font-size: var(--body-text-regular-font-size, 14px) !important;
    line-height: var(--body-text-regular-line-height, 19px) !important;
    font-weight: var(--body-text-regular-font-weight, 400) !important;
    position: relative !important;
  }
  .body-text2 {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--body-text-medium-font-family, 'Montserrat Medium') !important;
    font-size: var(--body-text-medium-font-size, 14px) !important;
    line-height: var(--body-text-medium-line-height, 19px) !important;
    font-weight: var(--body-text-medium-font-weight, 500) !important;
    position: relative !important;
  }
  .body-text3 {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--body-text-semibold-font-family, 'Montserrat SemiBold') !important;
    font-size: var(--body-text-semibold-font-size, 14px) !important;
    line-height: var(--body-text-semibold-line-height, 19px) !important;
    font-weight: var(--body-text-semibold-font-weight, 600) !important;
    position: relative !important;
  }
  .body-text4 {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--body-text-bold-font-family, 'Montserrat Bold') !important;
    font-size: var(--body-text-bold-font-size, 14px) !important;
    line-height: var(--body-text-bold-line-height, 19px) !important;
    font-weight: var(--body-text-bold-font-weight, 700) !important;
    position: relative !important;
  }
  .footnote {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: var(--footnote-light-font-family, 'Montserrat Light') !important;
    font-size: var(--footnote-light-font-size, 12px) !important;
    line-height: var(--footnote-light-line-height, 16px) !important;
    font-weight: var(--footnote-light-font-weight, 300) !important;
    position: relative !important;
  }
  .footnote2 {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: 'Montserrat Regular' !important;
    font-size: 12px !important;
    line-height: 16px !important;
    font-weight: 400 !important;
    position: relative !important;
  }
  .footnote3 {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: 'Montserrat Medium' !important;
    font-size: 12px !important;
    line-height: 16px !important;
    font-weight: 500 !important;
    position: relative !important;
  }
  .footnote4 {
    color: var(--grey-95, #0c0d0d) !important;
    text-align: left !important;
    font-family: 'Montserrat SemiBold' !important;
    font-size: 12px !important;
    line-height: 16px !important;
    font-weight: 600 !important;
    position: relative !important;
  }

  /* Button */
  .button,
  .button * {
    box-sizing: border-box;
  }

  .button {
    :not(.no-background){
    background: var(--blue-50, #0095ff);
    }
    border-radius: 10px;
    padding: 10px 20px 10px 20px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
    position: relative;
    border: none;
    font-family: "Montserrat Medium";
    
    font-size: 14px;
    white-space: pre;
    
    :is(.setHeight) {
      height: 35px;
    }
    
    &:disabled {
      :not(.no-background){
        background: var(--grey-5, #f2f2f3) !important;
      }
    }
  }

  /* .label {
  color: var(--white, #ffffff);
  text-align: left;
  font-family: var(--body-medium-font-family, "Montserrat Medium");
  font-size: var(--body-medium-font-size, 16px);
  line-height: var(--body-medium-line-height, 22px);
  font-weight: var(--body-medium-font-weight, 500);
  position: relative;
  } */

  /* variant styles */
  .button.size-m {
    border-radius: 8px;
    gap: 8px;
  }

  .button.label-type-text-only.size-m,
  .button.label-type-leading-icon-text.size-m,
  .button.label-type-trailling-icon-text.size-m {
    padding: 8px 16px 8px 16px;
  }

  .button.size-m .label {
    font-family: var(--body-text-medium-font-family, 'Montserrat Medium', sans-serif);
    font-size: var(--body-text-medium-font-size, 14px);
    line-height: var(--body-text-medium-line-height, 19px);
    font-weight: var(--body-text-medium-font-weight, 500);
  }

  .button.size-s {
    border-radius: 6px;
    gap: 6px;
  }

  .button.label-type-text-only.size-s,
  .button.label-type-leading-icon-text.size-s,
  .button.label-type-trailling-icon-text.size-s {
    padding: 6px 12px 6px 12px;
  }

  .button.size-s .label {
    font-family: var(--footnote-medium-font-family, 'Montserrat Medium', sans-serif);
    font-size: var(--footnote-medium-font-size, 12px);
    line-height: var(--footnote-medium-line-height, 16px);
    font-weight: var(--footnote-medium-font-weight, 500);
  }

  .button.button-type-bezeled {
    background: var(--blue-5, #e6f4ff);
  }

  .button.button-type-bezeled,
  .button.button-type-bezeled label,
  .button.button-type-bezeled-grey,
  .button.button-type-bezeled-grey label,
  .button.button-type-borderless,
  .button.button-type-borderless label,
  .button.button-type-bezeled:hover,
  .button.button-type-bezeled:hover label,
  .button.button-type-bezeled.state-hover,
  .button.button-type-bezeled.state-hover label,
  .button.button-type-bezeled-grey:hover,
  .button.button-type-bezeled-grey:hover label,
  .button.button-type-bezeled-grey.state-hover,
  .button.button-type-bezeled-grey.state-hover label,
  .button.button-type-bezeled.state-pressing,
  .button.button-type-bezeled.state-pressing label,
  .button.button-type-bezeled-grey.state-pressing
    .button.button-type-bezeled-grey.state-pressing
    label {
    color: var(--blue-50, #0095ff) !important;
  }

  .button.button-type-filled {
    background: var(--blue-50, #0077cc);
    color: var(--white);
  }

  .button.button-type-bezeled-grey,
  .button.button-type-filled.state-disabled,
  .button.button-type-bezeled.state-disabled,
  .button.button-type-bezeled-grey.state-disabled {
    background: var(--grey-5, #f2f2f3);   
  }

  .button.button-type-borderless {
    background: unset;
  }

  .button.button-type-filled .play-arrow,
  .button.button-type-bezeled .play-arrow,
  .button.button-type-bezeled-grey .play-arrow,
  .button.button-type-borderless .play-arrow {
    flex-shrink: 0;
    position: relative;
    overflow: visible;
  }

  .button.size-l .play-arrow {
    width: 22px;
    height: 22px;
  }

  .button.size-m .play-arrow {
    width: 19px;
    height: 19px;
  }

  .button.size-s .play-arrow {
    width: 16px;
    height: 16px;
  }

  .button.label-type-icon-only.size-l {
    padding: 10px;
  }

  .button.label-type-icon-only.size-m {
    padding: 8px;
  }

  .button.label-type-icon-only.size-s {
    padding: 6px;
  }

  .button.button-type-filled:hover,
  .button.button-type-filled.state-hover {
    :not(.no-background){
      background: var(--blue-60, #0077cc);
    }
    color: white;
  }

  .button.button-type-bezeled:hover,
  .button.button-type-bezeled.state-hover {
    background: var(--blue-10, #cceaff);
  }

  .button.button-type-bezeled-grey:hover,
  .button.button-type-bezeled-grey.state-hover {
    background: var(--grey-10, #e4e5e7);
  }

  .button.button-type-borderless:hover .label,
  .button.button-type-borderless.state-hover .label {
    color: var(--blue-60, #0077cc);
  }

  .button.button-type-filled.state-pressing {
    background: var(--blue-70, #005999);
  }

  .button.button-type-bezeled.state-pressing {
    background: var(--blue-20, #99d5ff);
  }

  .button.button-type-bezeled-grey.state-pressing {
    background: var(--grey-20, #c9cbcf);
  }

  .button.button-type-borderless.state-pressing .label {
    color: var(--blue-70, #005999);
  }

  .button.state-disabled .label {
    color: var(--grey-20, #c9cbcf);
  }

  /* Dropdowns */
  .filter-button-dropdown-global {
    border-radius: 8px;
    border: 1px solid var(--grey-20, #c9cbcf) !important;
    justify-content: space-between;
    background: var(--white, #fff) !important;
    display: flex;
    padding: 8px 16px !important;
    align-items: center;
    gap: 8px !important;
    align-self: stretch;
    box-shadow: none !important;

    color: var(--grey-95, #0c0d0d);

    /* Body text/Regular */
    font-family: 'Montserrat Regular';
    font-size: 14px;
    font-style: normal;
    line-height: 19px; /* 135.714% */
  }

  .filter-button-dropdown-global.auto-height {
    padding: 4px 16px 4px 4px !important;
  }

  .filter-button-dropdown-global:hover {
    border: 1px solid var(--grey-20, #c9cbcf);
    background: var(--grey-5, #f2f2f3) !important;
  }

  .filter-button-dropdown-global.selected {
    background: var(--blue-5, #e6f4ff) !important;
    border: none !important;
    color: var(--blue-50, #0095ff) !important;
    span {
      color: var(--blue-50, #0095ff) !important;
    }

    .arrow-icon {
      filter: var(--blue-50);
    }
  }

  .filter-button-dropdown-global.selected:hover {
    background: var(--blue-5, #e6f4ff) !important;
    border: none !important;
    color: var(--blue-50, #0095ff) !important;
    span {
      color: var(--blue-50, #0095ff) !important;
    }
  }

  .content-filter-dropdown {
    .brand-filter-button {
      background: var(--white);
      border: 1px solid var(--grey-20, #c9cbcf) !important;
      padding: 8px 16px;
    }
    .selected-brands {
      color: var(--grey-95);
      max-width: 85%;

      .brands-filter-tile {
        display: flex;
        padding: 4px 8px;
        justify-content: space-between;
        gap: 4px;
        font-family: 'Montserrat Regular';
        border-radius: 4px;
        background: var(--grey-10, #e4e5e7);
        color: var(--grey-95);
        margin: 4px 0px;

        .brand-icon {
          width: 19px !important;
          height: 19px !important;
          object-fit: contain;
        }
      }
    }

    .brands-filter-tile span {
      font-style: normal;
      color: var(--Grey-30, #afb2b6);
      line-height: 19px;
      font-family: 'Montserrat Regular';
      color: var(--grey-95);
    }

    .dropdown-menu {
      /* padding: 8px 16px; */
      border: 1px solid var(--grey-20, #c9cbcf) !important;
      box-shadow: none !important;
      min-width: 100% !important;
      border-radius: 8px !important;
      input:not([type='checkbox']):not(#range-date-1):not(#range-date-2):not(#clear-btn-search),
      textarea {
        font-size: 14px;
        color: var(--grey-95);
        padding: 8px 16px !important;
        border-radius: 8px 8px 0px 0px !important;

        &:hover,
        &:focus {
          background-color: var(--grey-5, #f2f2f3) !important;
          box-shadow: none !important;
          outline-color: transparent !important;
          outline: none !important;
        }

        &:disabled {
          border: none !important;
          color: var(--grey-20) !important;
          outline-color: transparent !important;
          outline: none !important;

          * {
            color: var(--grey-20) !important;
          }
        }
      }
      img {
        width: 19px;
        height: 19px;
      }

      li {
        padding: 8px 16px;
        height: 35px;
        display: flex;
        align-items: center;
      }

      li:hover {
        background: var(--blue-5);
        overflow: hidden;

        a:hover {
          background: var(--blue-5);
          overflow: hidden;
        }
      }
    }

    .navbar-n-item .dropdown-menu {
      overflow: visible;
    }

    button:disabled {
      border: none !important;
      color: var(--grey-20) !important;
      background: var(--grey-5, #f2f2f3) !important;
      * {
        color: var(--grey-20) !important;
      }
      .arrow-icon {
        filter: var(--svg-grey-20-filter);
        opacity: 0.3;
      }
    }
  }

  /* Popover */
  .popover-menu {
    div:hover {
      background: var(--blue-5) !important;
    }
  }

  .popover-menu-status {
    div:hover {
      background-color: rgba(0, 0, 0, 0.1) !important;
    }

    .priority-badge:hover{
    background-color: rgba(0, 0, 0, 0.1) !important;
    }
  }


  /* Input Fields */

  /* -- Checkbox -- */
  input[type='checkbox'] {
    outline: none !important;
    :not(.setCustomWidth){
      width: 17px !important;
    }
    height: 17px !important;
  }

  input[type='checkbox'] {
    display: block !important;
    outline: none !important;
  }

  input[type='checkbox']:checked, input[type='checkbox']:checked:hover {
    background-color: var(--blue-50);
  }


  input[type='checkbox']:checked::before {
    display: block !important;
    margin: auto !important;
  }

  .checkbox input[type='checkbox'] {
    margin-left: -16px;
  }

  .check-box {
    display: none !important;
  }

  input[type='checkbox'] + .check-box:after {
    border: 1px solid var(--grey-20, #c9cbcf) !important;
    border-radius: 4px !important;
    :hover {
      background-color: var(--blue-60) !important;
    }
  }

  input[type='checkbox']:checked + .check-box:after {
    background-color: var(--blue-50);
    border: none !important;
  }

  .brand-icon {
    object-fit: contain;  
  }

  input[type='checkbox']:checked + .check-box:before {
    border: 2px solid white;
    border-top: 0;
    border-left: 0;
    width: 4.5px !important ;
    height: 8px;
    left: 5px;
    top: 3.5px !important;
  }

  input[type='checkbox']:after:hover + .check-box:after:hover {
    background-color: var(--blue-50) !important;
  }

  /* Styles Overlap */

  .custom-checkbox-container:not(.dropdown-menu .custom-checkbox-container) {
    input[type='checkbox'] {
      opacity: 1 !important;
      left: 0 !important;
      margin: 0 !important;
    }
  }

  /* Radio Boxes */
  /* 

  input ~ .radio-checkmark {
    border: 1px solid var(--grey-20, #C9CBCF)!important;
    opacity: 1!important;
    width: 18px!important;
    height: 18px!important;
    top: 1px!important;

    :hover {
      background: var(--grey-5, #F2F2F3)!important;
    }
  } */

  /* Hide native radio input */
  .radio-label input[type='radio'] {
    display: none;
  }

  /* Simple state */
  .radio-label .custom-radio {
    display: inline-block;
    position: relative;
    width: 18px;
    height: 18px;
    border-radius: 9px;
    border: 1px solid var(--grey-20, #c9cbcf);
    background: var(--white, #fff);
    cursor: pointer;
  }

  /* Hover state */
  .radio-label:hover .custom-radio {
    background: var(--grey-5, #f2f2f3);
    border: 1px solid var(--grey-20, #c9cbcf);
  }

  /* Checked state */
  .radio-label input[type='radio']:checked + .custom-radio {
    border: 6px solid var(--blue-50, #0095ff);
    background: var(--white, #fff);
  }
  /* 
  .radio-checkmark {
  display: none;
  } */

  /* Inner circle for checked state */
  .radio-label input[type='radio']:checked {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 6px;
    height: 6px;
    background: var(--white, #fff);

    border-radius: 50%;
  }

  /* Add additional styling for the label text */
  .radio-label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .radio-label span {
    :not(.custom-radio) {
      margin-left: 10px;
    }
    font-size: 16px;
    color: #000;
  }

  /* -- Text Field -- */

  input::placeholder,
  input::-webkit-input-placeholder,
  input::-moz-placeholder,
  input:-ms-input-placeholder,
  input:-moz-placeholder,
  textarea::placeholder,
  textarea::-webkit-input-placeholder,
  textarea::-moz-placeholder,
  textarea:-ms-input-placeholder,
  textarea:-moz-placeholder .input-component::placeholder {
    font-style: normal !important;
    color: var(--grey-30, #afb2b6) !important;
    font-family: 'Montserrat Regular' !important;
    opacity: 1 !important;
  }

  /* Remove spins in the number inputs */

  /* Hide the arrows in WebKit browsers */
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
      }

  /* Hide the arrows in Firefox */
  input[type=number] {
      -moz-appearance: textfield;
  }
  /* IE doesn't have spinners, so nothing special is required. Just keeping it consistent. */
  input[type=number] {
      -ms-appearance: textfield;
  }

  input[type='tel']:not(.multi-valued-select input):not(.dropdown-component input),
  input[type='tel']:not(.input-group input) {
    box-shadow: none !important;
  }

  /* General styles for all text inputs and textareas */
  input[type='text']:not(.multi-valued-search input):not(.unstyled-input):not(.multi-valued-select input):not(.dropdown-component input),
  input[type='number']:not(.input-group input),
  input[type='email']:not(.multi-valued-select input):not(.dropdown-component input),
  input[type='email']:not(.input-group input),
  textarea,
  .multi-valued-input,
  .input-component,
  .button-dropdown-global {
    :not(.no-background):not(&:disabled) {
      background-color: var(--white);
    }
    :not(.date-picker-error-wrapper input):not(.no-border):not(.has-error .form-control):not(
        .form-control input
      ):not(.form-control textarea):not(#range-date-1):not(#range-date-2) {
      border: 1px solid var(--grey-20, #c9cbcf) !important;
      border-radius: 8px !important;

    }
    outline: transparent !important;
    box-shadow: none !important;
    :not(.no-padding) {
      padding: 8px 16px !important;
    }

    font-style: normal !important;
    :not(textarea):not(.profile-input) {
      height: 35px !important;
    }
    font-size: 14px;
    color: var(--grey-95) !important;
    justify-content: space-between;
    outline-color: transparent !important;
    outline: none !important;
    font-family: 'Montserrat Regular' !important;
    border-radius: 8px !important;


    &:hover {
      :not(.no-background) {
        background-color: var(--grey-5, #f2f2f3) !important;
      }
      box-shadow: none !important;
      outline-color: transparent !important;
      outline: none !important;
    }

    &:focus {
      :not(.date-picker-error-wrapper input):not(.no-border):not(.has-error .error-wrapper):not(
          .has-error .form-control
        ):not(.form-control input):not(.form-control textarea) {
        border: 1px solid var(--grey-20, #c9cbcf) !important;
      }

      box-shadow: none !important;
      outline-color: transparent !important;
      outline: none !important;
    }

    &:disabled {
      border: none !important;
      color: var(--grey-20) !important;
      outline-color: transparent !important;
      outline: none !important;
    }
  }

  .no-border {
    border: none !important;
  }
  .no-background {
    background: none !important; 
    background-color: none !important;
  }

  .apply-input-style {
    :not(.no-border) {
      border: 1px solid var(--grey-20, #c9cbcf) !important;
    }
    box-shadow: none !important;
    border-radius: 8px !important;
    height: auto;
    font-family: 'Montserrat Regular' !important;
    font-style: normal !important;

    &:hover {
      background-color: var(--grey-5, #f2f2f3) !important;
      box-shadow: none !important;
    }
    &:focus {
      outline-color: transparent !important;
      outline: none !important;
    }
    &:disabled {
      border: none !important;
      color: var(--grey-20) !important;
    }
  }

  .apply-input-border {
    border: 1px solid var(--grey-20, #c9cbcf) !important;
    border-radius: 8px !important;
    outline-color: transparent !important;
    outline: none !important;
  }

  .button-font {
    font-family: 'Montserrat Medium';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
  }

  /* Override the styles for inputs and textareas within .dropdown-component and .select-component-form-group */

  .dropdown-component-with-input {
    background-color: var(--white) !important;
    border: 1px solid var(--grey-20, #c9cbcf) !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    height: 35px;
    /* padding: 0 !important; */

    input {
      background-color: initial !important;
      border: none !important;
      box-shadow: none !important;
      /* padding: 0 !important; */
    }
  }

  .dropdown-component input[type='text'],
  .dropdown-component textarea,
  .select-component-form-group input[type='text'],
  .select-component-form-group textarea .multi-valued-input input[type='text'],
  .multi-valued-input textarea,
  .number-input-container input[type='number'] {
    background-color: initial !important;
    border: none !important;
    border-radius: initial !important;
    box-shadow: initial !important;
    :not(.dropdown-component input) {
      padding: initial !important;
    }
  }

  .multi-valued-input.no-input {
    height: 0 !important;
    padding-top: 7px !important;
  }

  .dropdown-component {
    outline: none !important;
    box-shadow: none !important;
    :not(.full-width) {
      width: 256px;
    }
    /* DEPRICATED */
/* 
    input {
      padding: 0px 16px !important;
    } */

    :focus {
      border: var(--border-grey-20) !important;
    }
  }

  .dropdown-menu {
    .search-input-group-discover {
      margin-bottom: 24px !important;

      img {
        left: 24px !important;
        top: 8px !important;
      }

      input[type='text'] {
        margin: 10px !important;
        margin-top: 0px !important;
      }
    }
  }

  .multi-valued-select {
    input {
      padding: 0px 0px 0px 16px !important;
    }
  }

  .input-field-global {
    background: var(--white, #ffffff);
    border-radius: 8px;
    border-style: solid !important;
    border-color: var(--grey-20, #c9cbcf) !important;
    border-width: 1px !important;
    padding: 8px 16px 8px 16px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    height: fit-content;
  }

  .input-field-global:hover {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
  }

  #clear-btn-search {
    padding-left: 43px !important;
  }

  .clear-btn-search.right-icon {
    padding: 0 !important;
    padding-left: 16px !important;
    margin: 0 !important;
    height: 100% !important;
    border-radius: 8px !important;
    max-width: calc(100% - 39px) !important;
  }

  .right-icon-input-group {
    .input-group-addon {
      margin-top: 8px;
    }
  }

  .input-padding {
    padding: 8px 16px 8px 16px !important;
  }

  .input-left-right-padding {
    padding: 0px 16px !important;
  }

  .no-border-radius {
    border-radius: 0 !important;
  }

  .grey-40-svg {
    filter: invert(70%) sepia(5%) saturate(344%) hue-rotate(177deg) brightness(87%) contrast(84%);
  }

  .grey-50-svg {
    filter: var(--svg-grey-50-filter);
  }

  .blue-5-svg {
    filter: invert(100%) sepia(40%) saturate(6971%) hue-rotate(177deg) brightness(109%) contrast(101%);
  }

  .blue-50-svg {
    filter: var(--svg-blue-50-filter);
  }
  .blue-60-svg {
    filter: var(--svg-blue-60-filter);
  }

  /* Others */

  .help-block {
    color: var(--Red-50, #fc2c03) !important;
    font-size: 12px !important;
    font-style: normal !important;
    line-height: 16px !important;
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
  }

  .error-wrapper {
    width: 100%;
    outline-color: transparent;
    outline: none !important;
    /* padding: 8px 16px; */
  }
  .has-error {
    .form-control,
    .error-wrapper {
      border: 2px solid var(--red-50, #fc2c03) !important;
      border-radius: 8px !important;
      outline: none !important;
      &:hover,
      &:focus {
        border: 2px solid var(--red-50, #fc2c03) !important;
        outline: none !important;
      }
    }

    .control-label {
      color: inherit
    }
  }

  .add-error-border {
    border: 2px solid var(--red-50, #fc2c03) !important;
    border-radius: 8px !important;
    outline: none !important;
    &:hover,
    &:focus {
      border: 2px solid var(--red-50, #fc2c03) !important;
      outline: none !important;
    }
  }

  .ellipsisText {
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    max-width: 100%;
    overflow: hidden;
  }

  table {
    border: 1px solid var(--grey-5, #f2f2f3) !important;
    border-radius: 10px 10px 0px 0px !important;
  }

  #react-select-2-input {
    border: none !important;
    background-color: transparent !important;
  }

  .product-media-container {
    width: 100%;
  }

  .progress-bar {
    box-shadow: none !important;
  }

  .DateInput_input {
    ::placeholder {
      color: var(--grey-30, #afb2b6) !important;
      font-style: normal !important;
      font-family: 'Montserrat Light' !important;
    }
  }

  .date-picker-error-wrapper input {
    border: 2px solid var(--red-50, #fc2c03) !important;
  }

  .tooltip-container,
  .__react_component_tooltip .tooltip-container,
  .react-tooltip,
  .__react_component_tooltip .tooltip-title {
    border-radius: 8px !important;
    background: var(--grey-5, #f2f2f3) !important;
    box-shadow: none !important;
    border: var(--border-grey-20) !important;
    max-width: 540px !important;
    padding: 8px 16px !important;

    p,
    .tooltip-text {
      color: var(--grey-50, #797e86) !important;
      font-family: 'Montserrat Regular' !important;
      font-size: 14px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      line-height: 19px !important; /* 135.714% */
      padding: 0 !important;
    }
    * {
      padding: 0 !important;
    }
    img {
      display: none !important;
    }
  }

`;
